import { LayoutInterval } from '../interfaces/LayoutInterval';

/**
 * Merges array of layout intervals into a single interval.
 * @param intervals An array of layout intervals.
 * @returns A single aggregate interval.
 */
export function merge(intervals: LayoutInterval[]): LayoutInterval {
    let startInterval = intervals[0];
    let endInterval = intervals[intervals.length - 1];
    return {
        start: startInterval.start,
        end: endInterval.end,
        clippedLeft: startInterval.clippedLeft,
        clippedRight: endInterval.clippedRight,
    };
}
